export const SET_SHOW_ADMIN_VIEW = "SET_SHOW_ADMIN_VIEW"
export const CHANGE_USER_STATUS = "CHANGE_USER_STATUS"
export const DELETE_ASSIGNED_ROLE = "DELETE_ASSIGNED_ROLE"
export const UPDATE_ROLE = "UPDATE_ROLE"
export const ASSIGN_ROLE = "ASSIGN_ROLE"
export const GET_CONSTITUENT_ROLES = "GET_CONSTITUENT_ROLES"
export const RECEIVE_CONSTITUENT_ROLES = "RECEIVE_CONSTITUENT_ROLES"
export const RECEIVE_DELETE_ROLE_ERROR = "RECEIVE_DELETE_ROLE_ERROR"
export const CREATE_ROLE = "CREATE_ROLE"
export const RECEIVE_ROLES = "RECEIVE_ROLES"
export const GET_ROLES = "GET_ROLES"
export const DELETE_ROLE = "DELETE_ROLE"
export const GET_USERS = "GET_USERS"
export const RECEIVE_USERS = "RECEIVE_USERS"
export const RECEIVE_NEW_USERS = "RECEIVE_NEW_USERS"

export const setShowAdminView = (showAdminView) => ({
  type: SET_SHOW_ADMIN_VIEW,
  showAdminView,
})

export const changeUserStatus = (params, success, error) => ({
  type: CHANGE_USER_STATUS,
  params,
  success,
  error,
})

export const receiveDeleteRoleError = () => ({
  type: RECEIVE_DELETE_ROLE_ERROR,
})

export const getRoles = (success, error) => ({
  type: GET_ROLES,
  success,
  error,
})

export const getConstituentRoles = (success, error) => ({
  type: GET_CONSTITUENT_ROLES,
  success,
  error,
})

export const deleteRole = (roleId, success, error) => ({
  type: DELETE_ROLE,
  roleId,
  success,
  error,
})
export const deleteAssignedRole = (assignedRoleId, success, error) => ({
  type: DELETE_ASSIGNED_ROLE,
  assignedRoleId,
  success,
  error,
})

export const updateRole = (roleId, params, success, error) => ({
  type: UPDATE_ROLE,
  roleId,
  params,
  success,
  error,
})

export const createRole = (params, success, error) => ({
  type: CREATE_ROLE,
  params,
  success,
  error,
})

export const assignRole = (params, success, error) => ({
  type: ASSIGN_ROLE,
  params,
  success,
  error,
})

export const receiveRoles = (roles, success, error) => ({
  type: RECEIVE_ROLES,
  roles,
  success,
  error,
})

export const receiveConstituentRoles = (constituentRoles) => ({
  type: RECEIVE_CONSTITUENT_ROLES,
  constituentRoles,
})

export const getUsers = (success, error, currentPage) => ({
  type: GET_USERS,
  success,
  error,
  currentPage,
})

export const receiveUsers = (resp, success, error) => ({
  type: RECEIVE_USERS,
  resp,
  success,
  error,
})

export const receiveNewUsers = (resp, success, error) => ({
  type: RECEIVE_NEW_USERS,
  resp,
  success,
  error,
})
